import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, switchMap } from 'rxjs/operators';
import { ProductsStoreService } from 'src/app/core/store/services/products-store.service';
import { CATEGORY_DELETE_EVENT } from '../../dictionaries/socket-events';
import { WebSocketService } from '../../services/web-socket.service';
import {
  IDEAS_ADD_SUCCESS,
  IDEAS_DEL_SUCCESS,
  IDEAS_SAVE_SUCCESS,
  IdeasReqAddSuccessAction,
  IdeasReqDelSuccessAction,
  IdeasReqSaveSuccessAction,
} from '../actions/ideas';
import { CategoriesStoreService } from '../services/categories-store.service';

type IdeasListChageAction = IdeasReqAddSuccessAction | IdeasReqDelSuccessAction | IdeasReqSaveSuccessAction;

@Injectable()
export class CategoriesEffects {
  constructor(
    private actions$: Actions, //
    private websocketService: WebSocketService,
    private productsStore: ProductsStoreService,
    private categoriesStore: CategoriesStoreService,
  ) {}

  private readonly loadCategories$ = this.productsStore.activeData$.pipe(
    map((activaData) => activaData.selectedId),
    filter((selectedId): selectedId is string => !!selectedId),
    switchMap((workspaceId) => {
      return this.categoriesStore.loadList(workspaceId);
    }),
  );

  public ideasListChange$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType<IdeasListChageAction>(
          IDEAS_ADD_SUCCESS, //
          IDEAS_DEL_SUCCESS,
          IDEAS_SAVE_SUCCESS,
        ),
        switchMap(() => this.loadCategories$),
      );
    },
    { dispatch: false },
  );

  public onCategoryDelete$ = createEffect(
    () => {
      return this.websocketService.message$.pipe(
        filter((msg) => {
          return msg.event === CATEGORY_DELETE_EVENT;
        }),
        switchMap(() => this.loadCategories$),
      );
    },
    { dispatch: false },
  );
}
